export const P_CHAIN_INDEXER_DOMAIN = process.env.REACT_APP_INDEXER_URL;
export const HISTORY_API_DOMAIN = `${process.env.REACT_APP_DEPLOY_TARGET === "production" ? "https://flare.space/api/" : "https://flare-space-test.matheo.si/api/"}`;

export const FLARE_SPACE_DOMAIN = "https://flare.space";
export const GA_TRACKING_ID = "G-7YE516EVDL";
export const SENTRY_PROJECT_ID =
  "https://a3479903fdbd1173c3e169cf1dca83d2@sentry.matheo.si/15";
export const FETCH_NUMBER_OF_BLOCKS = 20;

export const CSV_DELIMITER = ";";

export const COOKIE_CONNECT_WALLET = "flare_space_connectWallet";

export const TRANSACTION_RETURN_LIMIT = 100;
export const CCHAIN_TRANSACTION_RETURN_LIMIT = 1000;

export const UNKNOWN_NAME = "Unknown";

export const CLOSE_ICON_URL = "https://flare-space-test.matheo.si/images/close-gray.svg";
